/**
 * URL del Django Admin.
 * - En Vite (:3002/:3000): fuerza host sin puerto de app → nginx :80
 * - En nginx (:80) o Django directo (:8015): no reescribe el puerto
 */
export function getDjangoAdminUrl(path = '/admin/') {
  if (typeof window === 'undefined') return path
  const { protocol, hostname, port } = window.location
  const normalized = path.startsWith('/') ? path : `/${path}`
  const withSlash =
    normalized === '/admin' || normalized.endsWith('/')
      ? (normalized === '/admin' ? '/admin/' : normalized)
      : `${normalized}/`

  const spaPorts = new Set(['3000', '3002', '5173'])
  if (spaPorts.has(port)) {
    return `${protocol}//${hostname}${withSlash}`
  }
  // Misma origen (incluye :8015 o :80)
  return withSlash
}

/**
 * Si el usuario abrió /admin en el puerto del frontend (Vite),
 * redirige al host en puerto 80 (nginx → Django).
 */
export function redirectAdminAwayFromSpa() {
  if (typeof window === 'undefined') return false
  const { pathname, port, protocol, hostname, search, hash } = window.location
  if (!pathname.startsWith('/admin')) return false

  const spaPorts = new Set(['3000', '3002', '5173'])
  if (!spaPorts.has(port)) return false

  const targetPath = pathname === '/admin' ? '/admin/' : pathname
  window.location.replace(`${protocol}//${hostname}${targetPath}${search}${hash}`)
  return true
}
